import { render, staticRenderFns } from "./tooltips.vue.js?vue&type=template&id=6c450d78!=!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./tooltips.vue?vue&type=template&id=6c450d78"
import script from "./tooltips.vue.js?vue&type=script&lang=js!=!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./tooltips.vue?vue&type=script&lang=js"
export * from "./tooltips.vue.js?vue&type=script&lang=js!=!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./tooltips.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/gitlab-gdk/gitlab-development-kit/gitlab/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6c450d78')) {
      api.createRecord('6c450d78', component.options)
    } else {
      api.reload('6c450d78', component.options)
    }
    module.hot.accept("./tooltips.vue.js?vue&type=template&id=6c450d78!=!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./tooltips.vue?vue&type=template&id=6c450d78", function () {
      api.rerender('6c450d78', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tooltips/components/tooltips.vue"
export default component.exports